import React from "react"

import ActivityCard from './ActivityCard';
import Quote from './Quote';
import SectionDivider from './SectionDivider';
import styles from './ActivityCard.module.css';

const Activity = ({ jobs, education, volunteer, quotes, splashQuote }) => {
  return (
    <div className="fullSection">

      <div className="whitespace" />
      <div className="whitespace" />
      <div className="header"> Experience: </div>

      <div className={styles.years}> 2.5+ years</div>

      <Quote
        text={splashQuote.text}
        name={splashQuote.name} title={splashQuote.title}
      />

      <div className="whitespace" />

      <div className={styles.wrapper}>
        <div className={styles.line}/>

        <div className={styles.items}>

            {
              jobs.map( job => <ActivityCard
                title={job.title}
                description={job.description}
                company_name={job.company_name}
                dates={job.dates}
              />)
            }

          </div>

        </div>

    </div>
  )
}

export default Activity
